import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCodepen,
  faTwitter,
  faInstagram,
  faLinkedin,
  faGithub,
} from '@fortawesome/free-brands-svg-icons';
function ContentOne() {
  return (
    <div className="intro-wrap">
      <div className="intro-greet">Hello, I'm </div>
      <div className="intro-name">Karthik Sista</div>
      <div className="social-container">
        <a href="https://github.com/karthiksista" className="medium social">
          <FontAwesomeIcon icon={faGithub} size="2x" />
        </a>
        <a href="https://codepen.io/karthiksista" className="codepen social">
          <FontAwesomeIcon icon={faCodepen} size="2x" />
        </a>
        <a
          href="https://www.linkedin.com/in/karthik-sista-67094181/"
          className="linkedIn social"
        >
          <FontAwesomeIcon icon={faLinkedin} size="2x" />
        </a>
        <a href="https://twitter.com/Karthik_Sista" className="twitter social">
          <FontAwesomeIcon icon={faTwitter} size="2x" />
        </a>
        <a
          href="https://www.instagram.com/karthik_sista/"
          className="instagram social"
        >
          <FontAwesomeIcon icon={faInstagram} size="2x" />
        </a>
      </div>
    </div>
  );
}

export default ContentOne;
